import selectFilters from './SelectFilters.js';

const addToApplied = (appliedFilters, filter, values, activeTab) => {
    const newValues = (filter.type === "DATE" || filter.type === 'DATE_YEAR_ONLY') ?
                        values.map(val =>
                            {
                                const firstDate = val.label.split(';')[0];
                                const lastDate = val.label.split(';')[1];

                                return firstDate && lastDate ? {
                                    ...val,
                                    label: `${firstDate && firstDate.indexOf('-') >= 0 ?
                                              `${firstDate.replace('-', '')} p.n.e.`
                                              : firstDate} - ${lastDate && lastDate.indexOf('-') >= 0 ?
                                              `${lastDate.replace('-', '')} p.n.e.`
                                               : lastDate}`
                                } : false
                            }).filter(val => val)
                        : values;

    return [
              ...appliedFilters,
              {
                  id: filter.name,
                  label: filter.name,
                  value: newValues,
                  tab: filter.common ? 'common': activeTab.name,
                  ...filter
              }
          ];
};

const modifyApplied = (appliedFilters, filter, values, activeTab) => {
    const newValues = (filter.type === "DATE" || filter.type === 'DATE_YEAR_ONLY') ?
                        values.map(val =>
                            {
                                const firstDate = val.label.split(';')[0];
                                const lastDate = val.label.split(';')[1];

                                return firstDate && lastDate ? {
                                    ...val,
                                    label: `${firstDate && firstDate.indexOf('-') >= 0 ?
                                              `${firstDate.replace('-', '')} p.n.e.`
                                              : firstDate} - ${lastDate && lastDate.indexOf('-') >= 0 ?
                                              `${lastDate.replace('-', '')} p.n.e.`
                                               : lastDate}`
                                } : false
                            }).filter(val => val)
                        : values;

    return appliedFilters.map(appliedFilter => appliedFilter.id === filter.name && activeTab.name === appliedFilter.tab ?
              {
                  ...appliedFilter,
                  value: newValues
              } : appliedFilter);
};

export default function(appliedFilters, activeTab) {
    const filters = activeTab.allowedFilters;
    let newAppliedFilters = [...appliedFilters];

    filters.forEach(function(filter) {
        const isFilterApplied = newAppliedFilters.filter(appliedFilter => appliedFilter.id === filter.name && (activeTab.name === appliedFilter.tab || appliedFilter.tab === 'common')).length > 0;

        switch (filter.type) {
            case 'TREE_ID':
            case 'ID':
            case 'FACETING_API':
            case 'COMMON_ID':
                const optionsSelected = selectFilters(filter.options);

                if (optionsSelected.length > 0) {
                    newAppliedFilters = isFilterApplied ? modifyApplied(newAppliedFilters, filter, optionsSelected, activeTab)
                                                      : addToApplied(newAppliedFilters, filter, optionsSelected, activeTab);
                }

                break;
            case 'DATE':
            case 'DATE_YEAR_ONLY':
                if (filter.values) {
                    const newValue = [{
                        id: decodeURIComponent(filter.values[0]),
                        label: decodeURIComponent(filter.values[0])
                    }];

                    newAppliedFilters = isFilterApplied ? modifyApplied(newAppliedFilters, filter, newValue, activeTab)
                                                        : addToApplied(newAppliedFilters, filter, newValue, activeTab);
                }

                break;
            default:
                break;
        }
    });

    return newAppliedFilters;
};



// WEBPACK FOOTER //
// ./src/scripts/AppliedFilters.js